<!--
TODO:
    - multithreading/snackbars stack
    - vuex independent
    - alert/prompt/confirm types
-->
<template>
    <div v-if="snackbar.open" id="snackbar"
         :style="{bottom: bottom, opacity: opacity}">
        <div class="row">
            <div id="snackbar-type" :class="typeClass"></div>
            <div id="snackbar-content">
                <div class="col align-self-center">
                    <span v-html="snackbar.text"></span>
                    <p v-if="snackbar.caption" v-html="snackbar.caption" id="snackbar-caption"></p>
                </div>
            </div>
            <div v-if="snackbar.withClose" @click="hide" id="snackbar-close">
                <i class="fal fa-times fa-sm"></i>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {ERROR, INFO, SUCCESS, WARNING} from '@/store/modules/ui/UI'

export default {
    name: 'Snackbar',
    data() {
        return {
            bottom: '-250px',
            opacity: 0,
            timer: null
        }
    },
    methods: {
        show() {
            this.bottom = '16px'
            this.opacity = 1

            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                this.hide()
            }, this.snackbar.duration)
        },
        hide() {
            this.bottom = '-250px'
            this.opacity = 0
            this.timer = null
        }
    },
    computed: {
        ...mapGetters(['snackbar']),

        typeClass() {
            if (this.snackbar.type === SUCCESS) {
                return 'snackbar-success'
            } else if (this.snackbar.type === WARNING) {
                return 'snackbar-warning'
            } else if (this.snackbar.type === ERROR) {
                return 'snackbar-dander'
            } else if (this.snackbar.type === INFO) {
                return 'snackbar-info'
            }
            return ''
        }
    },
    watch: {
        snackbar(data) {
            if (data.open) {
                this.show()
            } else {
                this.hide()
            }
        }
    }
}
</script>

<style scoped lang="scss">
#snackbar {
    position: fixed;
    right: 160px;
    max-height: 250px;
    z-index: 100000;
    transition: all .75s;
    box-shadow: 11px 4px 16px 7px rgba(0, 0, 0, 0.2);
    @include media-breakpoint-down(sm) {
        right: 110px;
    }
}

#snackbar-content {
    display: flex;
    min-height: 50px;
    min-width: 250px;
    max-height: 250px;
    max-width: 700px;
    /*color: white;*/
    overflow-y: auto;
    background: #fff;
    text-align: left;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    padding: 10px 16px 10px 10px;
    font-size: 17px;

    #snackbar-caption {
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 0;
    }

    @include media-breakpoint-down(sm) {
        min-width: 220px;
        max-width: 220px;
    }
}

#snackbar-close {
    position: absolute;
    top: 2px;
    right: -8px;
    color: $color-dark;
    font-size: 18px;

    &:hover {
        transform: scale(1.1);
        transition: all .2s;
        cursor: pointer;
    }
}

#snackbar-type {
    min-height: 50px;
    width: 6px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    box-shadow: inset 0 0 12px rgba(0, 0, 0, .6);
}

.snackbar-success {
    background: var(--success);
}

.snackbar-dander {
    background: var(--danger);
}

.snackbar-warning {
    background: var(--warning);
}

.snackbar-info {
    background: var(--gray);
}
</style>
